import { type BranchKey, LayerKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'
import { CollapsedText } from '@festina-life/ui/structure'
import type { ReactNode } from 'react'

import { useMetaModelContext } from '../../../../context/metaModelContext'
import type { ConciseChangesetWithBranchKey } from '../../../../uiModels/changesets/types'
import { BlockIndicator } from '../../../blockIndicator/BlockIndicator'
import { LayerIndicator } from '../../../layerIndicator/LayerIndicator'
import { ChangesetAttributes } from './ChangesetAttributes'
import { ChangesetKey } from './ChangesetKey'
import { ChangesetOriginIndicator } from './ChangesetOriginIndicator'
import { ConciseChangesetOperationsList } from './ConciseChangesetOperationsList'
import type { ChangesetOrigin } from './types'

type Props = {
  changeset: ConciseChangesetWithBranchKey
  branchKey: BranchKey
  origin: ChangesetOrigin
  pullButton?: ReactNode
}

export const ConciseChangesetDetails = ({
  branchKey: currentBranchKey,
  changeset,
  origin,
  pullButton,
}: Props) => {
  const { blockTopology } = useMetaModelContext()
  const rootBlock = blockTopology.name
  const translate = useTranslate()
  const { description } = changeset

  return (
    <div className="flex-1 flex flex-col gap-y-2 min-w-0">
      <ChangesetAttributes changeset={changeset} className="@md:hidden" />
      <div className="flex justify-between items-center gap-x-2">
        <ChangesetKey changeset={changeset} />
        <div className="flex justify-end items-center gap-x-2">
          <BlockIndicator
            block={changeset.block ?? rootBlock}
            shouldShowIcon
            isSecondaryBackground={false}
          />
          <LayerIndicator
            shouldShowIcon
            layer={
              new LayerKey({
                tenantId: changeset.tenantId,
                layerId: changeset.layer,
              })
            }
            isSecondaryBackground={false}
          />
          <ChangesetOriginIndicator origin={origin} />
          {pullButton}
        </div>
      </div>
      <CollapsedText maxLength={200}>
        {description ?? translate('changesetList.noDescription')}
      </CollapsedText>
      <ConciseChangesetOperationsList
        branchKey={currentBranchKey}
        changeset={changeset}
      />
    </div>
  )
}
